import { PostOrPage } from "@tryghost/content-api";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";
import { BlogPostAuthor } from "../BlogPostAuthor";
import { BlogExcerpt } from "../ReusableStyledComponents/BlogExcerpt";
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink";
import { V3HeadlineH3 } from "../Typography";
import { VerticalSpacing } from "../VerticalSpacing";
import LazyLoad from "react-lazyload";
import { PostPreviewImage, PostPreviewTagBadge, PPImage } from "./BlogPostPreview.styles";

interface BlogPostPreviewProps {
    post: PostOrPage;
}

export const BlogPostPreview = ({ post }: BlogPostPreviewProps) => {
    return (
        <div>
            <VerticalSpacing bottom={24}>
                <UnstyledLink href={`${APPLICATION_ROUTES.BLOG}/${post.slug}`} aria-label={`Read more about ${post.title || ""}`}>
                    <PostPreviewImage>
                        <LazyLoad offset={500}>
                            <PPImage
                                src={post.feature_image || ""}
                                loading="lazy"
                                alt={`Preview image of ${post.title}`}
                                srcSet={`${post.feature_image || ""} 750w, ${post.feature_image || ""} 1050w,  ${post.feature_image || ""} 1750w`}
                                sizes={`(max-width: 48rem) 750w, (max-width: 64rem) 1050w, 1750w`}
                            />
                        </LazyLoad>
                    </PostPreviewImage>
                </UnstyledLink>
            </VerticalSpacing>
            <VerticalSpacing bottom={12}>
                <UnstyledLink href={`${APPLICATION_ROUTES.BLOG_TAG}/${post?.primary_tag?.slug}`}>
                    <PostPreviewTagBadge>{post?.primary_tag?.name}</PostPreviewTagBadge>
                </UnstyledLink>
            </VerticalSpacing>
            <VerticalSpacing bottom={12}>
                <UnstyledLink href={`${APPLICATION_ROUTES.BLOG}/${post.slug}`}>
                    <V3HeadlineH3 as="h2">{post.title}</V3HeadlineH3>
                </UnstyledLink>
            </VerticalSpacing>
            <VerticalSpacing bottom={18}>
                <UnstyledLink href={`${APPLICATION_ROUTES.BLOG}/${post.slug}`}>
                    <BlogExcerpt $numLines={3}>{post.excerpt}</BlogExcerpt>
                </UnstyledLink>
            </VerticalSpacing>
            <BlogPostAuthor post={post} isPostPreview />
        </div>
    );
};
